import { render, staticRenderFns } from "./invoice-new.vue?vue&type=template&id=6b822c94"
import script from "./invoice-new.vue?vue&type=script&lang=js"
export * from "./invoice-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports